import { Outlet } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import MobileCtaBar from "@/components/layout/MobileCtaBar";
import WhatsAppFloat from "@/components/layout/WhatsAppFloat";
import CookieConsent from "@/components/CookieConsent";
import MaintenanceGate from "@/components/MaintenanceGate";

export default function Layout() {
  return (
    <MaintenanceGate>
      <div className="min-h-screen bg-neutral-950">
        <Header />
        <main className="min-h-[60vh]">
          <Outlet />
        </main>
        <Footer />
        <MobileCtaBar />
        <WhatsAppFloat />
        <CookieConsent />
      </div>
    </MaintenanceGate>
  );
}
